<div class="page-inner-content-holder no-scroll flxClmn" *ngIf="scanMetrics">

    <trustifi-table-c
		class="trustifi-table" style="flex: 1 0; z-index: 5;"
		[list]="scanMetrics"
		[headers]="[
			{text: 'Sub Category', sortKey: 'sub_status', width: '250px'},
			{text: 'Category',     sortKey: 'status',     width: '145px'},
			{text: 'Description'},
		]"
		[cellsPrototype]="[
			{html: 'nameCell'},
			{html: 'statusCell'},
			{textKey: 'description'},
		]"
		(searchFunction)="searchMetrics($event)"
		[filterData]="filterData"
		[options]="{
			loadingTableFlag: loadingMetricsInProcess,
			itemsNameSingular: 'metric',
			isEllipsis: false,
			defaultSortKey: 'status',
		}"
	>
        <!-- Status summary chips -->
        <div tableButtons class="flex-row gap-2">
            <div *ngFor="let st of ['Malicious', 'Suspicious', 'Spam', 'Graymail']"
                 class="flex-row gap-2 align-items-center"
                 style="width: 120px; border-radius: 7px; padding: 6px 12px; cursor: pointer; transition: box-shadow 0.15s, opacity 0.15s; user-select: none;"
                 [ngStyle]="{
                     'background':  activeChipStatus === st ? statusConfig[st]?.color : statusConfig[st]?.bg,
                     'border':      '1px solid ' + statusConfig[st]?.color,
                     'box-shadow':  activeChipStatus === st ? '0 2px 8px ' + statusConfig[st]?.color + '55' : 'none',
                     'opacity':     activeChipStatus && activeChipStatus !== st ? '0.45' : '1'
                 }"
                 (click)="clickChipFilter(st)">
                <i [class]="statusConfig[st]?.icon + ' fa-fw'"
                   [ngStyle]="{'color': activeChipStatus === st ? 'white' : statusConfig[st]?.color}"></i>
                <div class="flex-column" style="line-height: 1.15;">
                    <b style="font-size: 1.1rem;"
                       [ngStyle]="{'color': activeChipStatus === st ? 'white' : statusConfig[st]?.color}">
                        {{(scanMetrics | filter:{status: st}).length}}
                    </b>
                    <span style="font-size: 0.9em; white-space: nowrap;"
                          [ngStyle]="{'color': activeChipStatus === st ? 'rgba(255,255,255,0.85)' : '#888'}">
                        {{st}}
                    </span>
                </div>
            </div>
        </div>

		<ng-template #customCells let-item let-cellId="cellId">

            <span *ngIf="cellId === 'nameCell'"
                  class="blue-link"
                  style="font-weight: 600; font-size: 0.9em; cursor: pointer;"
                  (click)="goToQuarantine(item)"
                  tooltip="View quarantined emails for this metric">
                {{item.sub_status}}
            </span>

            <span *ngIf="cellId === 'statusCell'"
                  style="display: inline-flex; align-items: center; gap: 5px; border-radius: 4px; padding: 3px 9px; font-size: 0.75em; font-weight: 700; letter-spacing: 0.04em; text-transform: uppercase; white-space: nowrap;"
                  [ngStyle]="{
                      'color':      statusConfig[item.status]?.color || item.color,
                      'background': statusConfig[item.status]?.bg    || 'transparent',
                      'border':     '1px solid ' + (statusConfig[item.status]?.color || item.color)
                  }">
                <i [class]="(statusConfig[item.status]?.icon || 'fa fa-circle') + ' fa-fw'"></i>
                {{item.status}}
            </span>

<!--            <div *ngIf="cellId === 'enabledCell'">
                <toggle-switch-c
                    [(model)]="item.enabled"
                    (onChange)="updateScanMetric(item)"
					[hideText]="true"
					[isDisabled]="!item.userConfigure || updateMetricInProcess">
                </toggle-switch-c>
            </div>-->

		</ng-template>

	</trustifi-table-c>
</div>
